<template>
  <configuration-stepper :links="links"></configuration-stepper>
  <div class="d-flex">
    <configuration-preview v-if="menu.id" :menuid="menu.id" :menu="menu"></configuration-preview>
    <div class="container" :style="menu.id && 'width: 62%'">
      <router-view v-if="menu.attributes" :menu="menu" @update:menu="menuDataHandler"></router-view>
      <base-spinner v-else></base-spinner>
      <buttons-prev-next :links="links"></buttons-prev-next>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';

import configurationPreview from '@/components/ConfigurationPreview';
import configurationStepper from '@/components/ConfigurationStepper';
import buttonsPrevNext from '@/components/ButtonsPrevNext';

import useMenus from '@/composables/useMenus';

export default {
  components: { configurationStepper, configurationPreview, buttonsPrevNext },
  props: {
    menuid: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const route = useRoute();

    const { menu, links, menuDataHandler, fetchMenu } = useMenus(route);

    onMounted(() => {
      fetchMenu(props.menuid);
    });

    return {
      links,
      menu,
      menuDataHandler,
    };
  },
};
</script>
